<template lang="pug">
el-container.main
    .main-header
        .welcome
            span.title 个人信息
        .welcome
            span.slogn 您在VSAT服务中使用的基本信息，例如您的姓名和邮箱
    .main-content
        .block
            .block-desc
                .desc-title 个人资料
                .desc-slogn 使用VSAT服务的其他用户可能会看到部分信息。
            .block-nav
                el-row(type="flex" @click.native="notSupport")
                    el-col(:span="6")
                        div 账号名
                    el-col(:span="12")
                        div {{ user.name }}
                    el-col(:span="6")
                        div
                            i.el-icon-arrow-right
            .block-nav
                el-row(type="flex" @click.native="editProfile('displayName')")
                    el-col(:span="6")
                        div 昵称
                    el-col(:span="12")
                        div {{user.displayName}}
                    el-col(:span="6")
                        div
                            i.el-icon-arrow-right
            .block-nav
                el-row(type="flex" @click.native="editPassword")
                    el-col(:span="6")
                        div 密码
                    el-col(:span="12")
                        div ········
                    el-col(:span="6")
                        div
                            i.el-icon-arrow-right

        .block
            .block-desc
                .desc-title 联系信息
                .desc-slogn 
                
            .block-nav
                el-row(type="flex" @click.native="editProfile('email')")
                    el-col(:span="6")
                        div 邮箱
                    el-col(:span="12")
                        div {{user.email}}
                    el-col(:span="6")
                        div(v-if="user.email === null")
                            span.uncertified 未认证
                            i.el-icon-arrow-right
                        div(v-else)
                            span.verified 已认证
                            i.el-icon-arrow-right
            .block-nav
                el-row(type="flex" @click.native="editProfile('phoneNumber')")
                    el-col(:span="6")
                        div 电话
                    el-col(:span="12")
                        div {{user.phoneNumber}}
                    el-col(:span="6")
                        div(v-if="user.phoneNumber === null")
                            span.uncertified 未认证
                            i.el-icon-arrow-right
                        div(v-else)
                            span.verified 已认证
                            i.el-icon-arrow-right

        .block(v-if="userOrgs.length !== 0")
            .block-desc
                .desc-title 组织信息
                .desc-slogn 若您已加入组织，则会展示该组织的信息
                
            .block-nav
                el-row(type="flex" @click.native="orgDetail")
                    el-col(:span="6")
                        div 组织代号
                    el-col(:span="12")
                        div {{userOrgs[0].org.name}}
                    el-col(:span="6")
                        div
                            i.el-icon-arrow-right
            .block-nav
                el-row(type="flex" @click.native="orgDetail")
                    el-col(:span="6")
                        div 组织名
                    el-col(:span="12")
                        div {{userOrgs[0].org.displayName}}
                    el-col(:span="6")
                        div
                            i.el-icon-arrow-right

    PasswordUpdate(:visible="display.PasswordUpdateForm" :editing="user" @hide="hidePasswordUpdateForm")
    ProfileUpdate(:visible="display.ProfileUpdateForm" :editing="user" :editItem="editItem" @hide="hideProfileUpdateForm" @refresh="refresh")
</template>

<script>
import { getUserAPI, getUserOrgsAPI } from "@/services";
import PasswordUpdate from "./PasswordUpdate";
import ProfileUpdate from "./Edit";
const defaultUpdateFrom = {
    email: "",
    displayName: ""
};
export default {
    name: "Profile",
    components: { PasswordUpdate, ProfileUpdate },
    props: [],
    data() {
        return {
            loading: false,
            page: {
                total: 1,
                number: 1
            },
            user: {},
            userOrgs: [],
            display: {
                PasswordUpdateForm: false,
                ProfileUpdateForm: false
            },
            editItem: null
        };
    },
    methods: {
        /**
         * Backend Service API Function Wrapper
         */
        async getUser() {
            this.loading = true;
            try {
                const res = await getUserAPI(localStorage.getItem("account"));
                if (res.status === 200) {
                    this.user = res.data;
                } else {
                    throw err;
                }
            } catch (err) {
                console.log(err);
                this.$message.error("获取信息失败，请刷新重试");
            }
        },
        async getUserOrgs() {
            this.loading = true;
            try {
                const res = await getUserOrgsAPI({
                    name: localStorage.getItem("account")
                });
                if (res.status === 200 && res.data.length) {
                    this.userOrgs = res.data;
                }
            } catch {
                console.log(localStorage.getItem("account"));
                console.log("获取用户组织信息失败，请刷新重试");
            } finally {
                this.loading = false;
            }
        },
        /**
         * UI Control
         */
        show(name) {
            this.display[name] = true;
        },
        hide(name) {
            this.display[name] = false;
        },
        refresh() {
            this.getUser();
        },
        hidePasswordUpdateForm() {
            this.hide("PasswordUpdateForm");
        },
        hideProfileUpdateForm() {
            this.hide("ProfileUpdateForm");
        },
        editPassword() {
            this.show("PasswordUpdateForm");
        },
        editProfile(item) {
            this.show("ProfileUpdateForm");
            this.editItem = item;
        },
        notSupport() {
            this.$message.info("暂不支持编辑");
        },
        orgDetail() {
            this.$router.push({ name: "organization" });
        }
    },
    mounted() {
        this.getUser();
        this.getUserOrgs();
    }
};
</script>

<style lang="stylus" scoped>
.main-header {
    flex-wrap: wrap;
}

.welcome {
    display: flex;
    height: 56px;
    align-items: center;
    flex-basis: 100%;
    background: #ffffff;

    .title {
        margin: auto;
        font-size: 30px;
    }

    .slogn {
        margin: auto;
        color: #cccccc;
    }
}

.main-content {
    flex-wrap: nowrap;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.block {
    display: flex;
    flex-wrap: wrap;
    flex-basis: 100%;
    flex-direction: column;
    width: 75%;
    max-width: 1000px;
    margin: 20px 10px 10px;
    border: solid 1px #bbbbbb;
    border-radius: 15px;
}

.block-desc {
    display: flex;
    flex-direction: column;

    .desc-title {
        display: flex;
        font-size: 20px;
        padding: 20px 20px 5px;
    }

    .desc-slogn {
        display: flex;
        font-size: 15px;
        color: #cccccc;
        // margin: 10px 0px;
        padding: 5px 20px 10px;
    }
}

.block-img {
    // display: flex;
    // flex-basis: 40%;
    margin: auto;

    img {
        width: 108px;
        height: 108px;
    }
}

.block-divider {
    margin: 0px;

    img {
        width: 120px;
        height: 120px;
    }
}

.block-nav {
    display: flex;

    &:last-child {
        .el-row {
            border-block-end: none;

            &:hover {
                border-bottom-left-radius: 15px;
                border-bottom-right-radius: 15px;
            }
        }
    }

    .uncertified {
        color: red;
        font-size: 12px;
        border: 1px solid red;
        padding: 5px;
        margin-right: 10px;
    }

    .verified {
        color: green;
        font-size: 12px;
        border: 1px solid green;
        padding: 5px;
        margin-right: 10px;
    }

    a {
        color: #39ABC0;
        text-decoration-line: none;
        margin-left: 10px;
    }

    // div {
    // top: 0;
    // bottom: 0;
    // margin: auto;
    // }
    .el-row {
        width: 100%;
        height: 100%;
        padding-top: 10px;
        border-bottom: solid 1px #bbbbbb;

        // border-block-end: none;
        &:hover {
            cursor: pointer;
            background: #F5F5F5;
        }
    }

    .el-col {
        margin-bottom: 10px;
        height: 36px;
        line-height: 36px;

        &:first-child {
            padding-left: 20px;
        }

        &:last-child {
            padding-right: 20px;
            text-align: right;
        }
    }
}
</style>
